import { render, staticRenderFns } from "./ThreadPost.vue?vue&type=template&id=08e36afc&scoped=true&"
import script from "./ThreadPost.vue?vue&type=script&lang=js&"
export * from "./ThreadPost.vue?vue&type=script&lang=js&"
import style0 from "./ThreadPost.vue?vue&type=style&index=0&id=08e36afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e36afc",
  null
  
)

export default component.exports